<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Exam Seating Arrangement</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-form ref="form" v-model="valid">
                <v-row justify="center" dense class="px-4 pt-2">
                    <v-col cols="12" sm="3" md="3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" item-value="ay_id"
                            :items="ay_list" item-text="ay" label="Academic Year" outlined
                            persistent-hint hint="Please Select Academic Year" :rules="[v => !!v || 'Required']"/>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="semester" item-value="id"
                            :items="sem_list" item-text="sem" label="Semester" outlined persistent-hint
                            hint="Please Select Semester" :rules="[v => !!v || 'Required']"/>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" item-value="id"
                            :items="std_list" item-text="name" label="Standard" outlined persistent-hint
                            hint="Please Select Standard" @change="getExamPlan()" :rules="[v => !!v || 'Required']"/>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="exam_plan" item-value="id"
                            :items="exam_plan_list" item-text="exam_name" label="Exam" outlined persistent-hint
                            hint="Please Select Exam" :rules="[v => !!v || 'Required']"/>
                    </v-col>
                </v-row>
            </v-form>
            <v-row justify="center">
                <v-col cols="auto" class="pt-0 mb-5 ml-9">
                    <v-btn color="primary" @click="fetchStudentSeatingReport()" small> Fetch </v-btn>
                </v-col>
            </v-row>

            <v-data-table :headers="headers" :items="student_seating_report" class="elevation-1 mytable" dense
                :search="search" v-if="student_seating_report.length > 0">
                <template v-slot:top>
                    <v-row dense class="px-2 pt-2" align="center">
                        <v-col cols="auto" class="pa-0">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile" small
                                class="mt-2 ml-2" :disabled="!student_seating_report.length">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export EXCEL
                            </v-btn>
                        </v-col>

                        <v-col cols="auto" class="pa-0 ml-1">
                            <v-btn rounded color="error" outlined @click="printPDF" small class="mt-2"
                                :disabled="!student_seating_report.length">
                                <v-icon left color="error">mdi-file-pdf-box</v-icon>
                                Export PDF
                            </v-btn>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
            
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
    data: () => ({
        valid: false,
        overlay: false,
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        ay: null,
        semester: null,
        standard: null,
        exam_plan: null,
        headers: [
            { text: "S.No", align: "left", sortable: false, value: "srno" },
            { text: "Exam Date", align: "left", sortable: true, value: "exam_date" },
            { text: "Day", align: "left", sortable: true, value: "day" },
            { text: "Slot No.", align: "left", sortable: true, value: "slot_no" },
            { text: "From Time", align: "left", sortable: true, value: "from_time" },
            { text: "To Time", align: "left", sortable: true, value: "to_time" },
            { text: "Subject Code", align: "left", sortable: true, value: "subject_code" },
            { text: "Subject Name", align: "left", sortable: true, value: "subject_name" },
            { text: "Conduct Type", align: "left", sortable: true, value: "conduct_type" },
            { text: "Room No", align: "left", sortable: true, value: "room_no" },
            { text: "Bench No", align: "left", sortable: true, value: "bench_no" },
            { text: "Bench Side", align: "left", sortable: true, value: "bench_side" },
            { text: "Standard", align: "left", sortable: true, value: "standard" },
            { text: "Stream", align: "left", sortable: true, value: "stream" },
        ],
        exam_plan_list: [],
        ay_list: [],
        sem_list: [],
        std_list: [],
        student_seating_report: [],
    }),

    mounted() {
        this.onLoad();
    },

    methods: {
        onLoad() {
            this.overlay = true;
            axios
                .post("/commonAPI/get_ay_std_div_by_access")
                .then((res) => {
                    if (res.data.msg == "200" || res.data.msg == 200) {
                        this.ay_list = res.data.data || [];
                        this.sem_list = res.data.semester_list || [];
                        this.std_list = res.data.standard_list || [];
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getExamPlan() {
            if (!this.ay || !this.standard || !this.semester) return;
            
            const data = {
                ay: this.ay,
                std: this.standard,
                sem: this.semester
            };
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getExamPlanList", data)
                .then((res) => {
                    if (res.data.msg == "200" || res.data.msg == 200) {
                        this.exam_plan_list = res.data.exam_plan_list || [];

                        if(this.exam_plan_list.length === 0){
                            this.showSnackbar("#b71c1c", "No exam found for this filters");
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        fetchStudentSeatingReport() {
            if (this.$refs.form && !this.$refs.form.validate()) {
                this.showSnackbar("#b71c1c", "Please select all mandatory fields.");
                return;
            }

            this.overlay = true;
            const data = {
                ay: this.ay,
                semester: this.semester,
                standard: this.standard,
                exam_plan: this.exam_plan
            };

            axios
                .post("/SeatingArrangement/fetchStudentSeatingReport", data)
                .then((res) => {
                    if (res.data.msg == "200" || res.data.msg == 200) {
                        const reportList = res.data.student_seating_report || [];
                        
                        this.student_seating_report = reportList.map((item, index) => ({
                            ...item,
                            srno: index + 1
                        }));

                        if (this.student_seating_report.length === 0) {
                            this.showSnackbar("#b71c1c", "No seating arrangement found for selected filters.");
                        }
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar || "Failed to fetch seating report.");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong while fetching data.");
                    console.error(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        downloadFile() {
            this.loader = true;
            const excelData = this.student_seating_report.map((item) => ({
                "S.No": item.srno,
                "Exam Date": item.exam_date,
                "Day": item.day,
                "Slot No": item.slot_no,
                "From Time": item.from_time,
                "To Time": item.to_time,
                "Subject Code": item.subject_code,
                "Subject Name": item.subject_name,
                "Conduct Type": item.conduct_type,
                "Room No": item.room_no,
                "Bench No": item.bench_no,
                "Bench Side": item.bench_side,
                "Standard": item.standard,
                "Stream": item.stream
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Exam Seating Arrangement Report");
            XLSX.writeFile(workbook, "ExamSeatingReport.xlsx");
            this.loader = false;
        },

        printPDF() {
            if (!this.student_seating_report.length) {
                this.showSnackbar("#b71c1c", "No data available to export.");
                return;
            }

            const printWindow = window.open("", "_blank");

            let html = `
                <html>
                <head>
                    <title>Exam Seating Arrangement Report</title>
                    <style>
                        @page {
                            size: A4 landscape;
                            margin: 8mm;
                        }

                        body {
                            font-family: Arial, sans-serif;
                            font-size: 9px;
                            margin: 0;
                        }

                        h2 {
                            text-align: center;
                            margin: 0 0 10px 0;
                            font-size: 16px;
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }

                        th,
                        td {
                            border: 1px solid #000;
                            padding: 4px;
                            text-align: left;
                            vertical-align: middle;
                            font-size:12px;
                        }

                        th {
                            background: #f2f2f2;
                            font-weight: bold;
                            text-align: center;
                        }

                        tr {
                            page-break-inside: avoid;
                        }
                    </style>
                </head>
                <body>

                <h2>Exam Seating Arrangement Report</h2>

                <table>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Exam Date</th>
                            <th>Day</th>
                            <th>Slot No.</th>
                            <th>From Time</th>
                            <th>To Time</th>
                            <th>Subject Code</th>
                            <th>Subject Name</th>
                            <th>Conduct Type</th>
                            <th>Room No</th>
                            <th>Bench No</th>
                            <th>Bench Side</th>
                            <th>Standard</th>
                            <th>Stream</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            this.student_seating_report.forEach((item, index) => {
                html += `
                    <tr>
                        <td>${item.srno || index + 1}</td>
                        <td>${item.exam_date || ""}</td>
                        <td>${item.day || ""}</td>
                        <td>${item.slot_no || ""}</td>
                        <td>${item.from_time || ""}</td>
                        <td>${item.to_time || ""}</td>
                        <td>${item.subject_code || ""}</td>
                        <td>${item.subject_name || ""}</td>
                        <td>${item.conduct_type || ""}</td>
                        <td>${item.room_no || ""}</td>
                        <td>${item.bench_no || ""}</td>
                        <td>${item.bench_side || ""}</td>
                        <td>${item.standard || ""}</td>
                        <td>${item.stream || ""}</td>
                    </tr>
                `;
            });

            html += `
                    </tbody>
                </table>

                </body>
                </html>
            `;

            printWindow.document.open();
            printWindow.document.write(html);
            printWindow.document.close();

            printWindow.onload = function() {
                printWindow.focus();
                printWindow.print();
            };
        },
    }
};
</script>